import { CoreSpaceHierarchyNode } from '@densityco/lib-api-types';
import { DisplaySpaceHierarchyNode } from '../types';

const flat = <T>(nestedArray: Array<Array<T>>): Array<T> => nestedArray.reduce((a, b) => [...a, ...b], []);

export function spaceHierarchyFormatter(hierarchy: Array<CoreSpaceHierarchyNode>): Array<DisplaySpaceHierarchyNode> {
  function recurseHierarchy(
    space: CoreSpaceHierarchyNode,
    ancestry = [] as Array<any>,
    depth = -1
  ): Array<DisplaySpaceHierarchyNode> {
    const parentId = ancestry.length > 0 ? ancestry[0].id : null;
    if (!space.children) {
      // Leaf of the tree
      return [{ depth: depth + 1, ancestry, children: [], space: { ...space, parentId } }];
    } else {
      // Regular node in the tree
      const children = flat(space.children.map((child) => recurseHierarchy(child, [space, ...ancestry], depth + 1)));

      return [
        {
          depth: depth + 1,
          ancestry,
          children: children.map((c) => c.space),
          space: { ...space, parentId },
        },
        ...children,
      ];
    }
  }

  return flat(hierarchy.map((space) => recurseHierarchy(space)));
}
